import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import teddyImg from '../assets/hero1.png';
import bunnyImg from '../assets/hero.png';
import yellowImg from '../assets/hero2.png';

const slides = [
  {
    image: teddyImg,
    title: 'You Think It,\nWe Build It',
    price: 'We create customized applications or systems tailored to meet your specific needs by solving unique challenges through technology.',
    btn: 'Explore More',
    path: '/explore-more',
    bgColor: 'white',
    small: true,
    glowColor: 'rgba(253, 179, 117, 0.7)', // Darker Aluminum
  },
  {
    image: bunnyImg,
    title: 'IT Consultancy',
    price: 'Providing strategic guidance, software architecture solutions, and seamless development to help businesses build scalable, efficient, and future-ready technology systems.',
    btn: "View More",
    path: "/view-more",
    bgColor: 'white',
    glowColor: 'rgba(255, 255, 153, 0.7)', // Darker Light Yellow
  },
  {
    image: yellowImg,
    title: 'AI & Automation',
    price: 'Implementing AI-powered solutions to optimize business processes, improve efficiency, and drive innovation.',
    btn: "Discover",
    path: "/discover",
    bgColor: 'white',
    glowColor: 'rgba(42, 82, 190, 0.7)', // Darker Cerulean
  },
];

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 4000);
    return () => clearInterval(slideTimer);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ width: '100%', overflow: 'hidden', marginTop: '60px' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          transition: 'transform 1s ease-in-out',
          transform: `translateX(-${currentSlide * 100}%)`,
          height: '100%', 
          
        }}
      >
        {slides.map((slide, index) => (
          <section
            key={index}
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              minWidth: '100%',
              padding: '65px',
              boxSizing: 'border-box',
              position: 'relative',
              background: slide.bgColor,
              textAlign: isMobile ? 'center' : 'left',
            }}
          >
            <div
              style={{
                flex: 1,
                paddingRight: isMobile ? '0' : '80px', // shifted text right as before
                marginLeft: isMobile ? '0' : '50px',
              }}
            >
              <h1
                style={{
                  fontSize: isMobile ? '2rem' : '3.6rem', // Increased font size
                  marginBottom: '1rem',
                  color: '#000',
                  whiteSpace: 'pre-line',
                  fontfamily: "Archivo", // Eye-catching font
                  letterSpacing: '2px', // Added letter spacing for a bolder look
                  fontWeight: 'bold', // Ensuring boldness
                  textTransform: 'uppercase', // Making it more attention-grabbing
                  lineHeight: '1.1', // Ensures good line spacing for readability
                }}
              >
                {slide.title}
              </h1>
              <p
                style={{
                  fontSize: isMobile ? '0.95rem' : '1.2rem',
                  color: '#000',
                  marginTop: '0.5rem',
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {slide.price}
              </p>
              <button
                onClick={() => navigate(slide.path)}
                style={{
                  fontSize: isMobile ? '0.8rem' : '1.1rem',
                  padding: '10px 30px',
                  backgroundColor: '#F19F4D',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  marginTop: '15px',
                  transition: 'background-color 0.3s',
                  fontFamily: "'Poppins', sans-serif",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#d8842f')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#F19F4D')}
              >
                {slide.btn}
              </button>
            </div>

            <div
              style={{
                flex: 1,
                textAlign: 'center',
                marginTop: isMobile ? '20px' : '0',
                position: 'relative',
              }}
            >
              {/* Animated Glow Background */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: slide.small ? '300px' : '420px',
                  height: slide.small ? '300px' : '420px',
                  borderRadius: '50%',
                  background: `radial-gradient(circle, ${slide.glowColor} 0%, rgba(249,207,0,0) 80%)`,
                  animation: 'glowPulse 3s ease-in-out infinite',
                  zIndex: 0,
                  filter: 'blur(40px)',
                }}
              />
              {/* Image */}
              <img
                src={slide.image}
                alt={slide.title}
                style={{
                  width: isMobile ? '80%' : slide.small ? '280px' : '400px',
                  height: 'auto',
                  zIndex: 1,
                  borderRadius: '20px',
                  transition: '0.5s ease',
                  transform: 'perspective(1000px) rotateY(0deg) scale(1)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.2)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'perspective(1000px) rotateY(10deg) scale(1.08)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'perspective(1000px) rotateY(0deg) scale(1)';
                }}
              />
            </div>
          </section>
        ))}
      </div>

      {/* Keyframes for glow animation */}
      <style>
        {`
          @keyframes glowPulse {
            0%, 100% {
              opacity: 0.7;
              transform: translate(-50%, -50%) scale(1);
            }
            50% {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1.2);
            }
          }
        `}
      </style>
    </div>
  );
}

export default Hero;
